"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reactDom = require("react-dom");

var _reactDom2 = _interopRequireDefault(_reactDom);

var _domHelpers = require("dom-helpers");

var _reactBootstrap = require("react-bootstrap");

var _contains = require("dom-helpers/query/contains");

var _contains2 = _interopRequireDefault(_contains);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var COUNTER = 0;

/**
 * Generate an id for the tooltip.
 *
 * @return {String} the tooltip id.
 */
function generateId() {
    return "uiw-tooltip-" + ++COUNTER;
}

/**
 * Trigger function factory. Returns a function that invokes each of the functions passed to the factory with the
 * arguments passed to it.
 *
 * @param fns {Array} and array of functions to invoke.
 * @returns {Function} a function that invokes each function with the arguments.
 */
function triggerFn() {
    for (var _len = arguments.length, fns = Array(_len), _key = 0; _key < _len; _key++) {
        fns[_key] = arguments[_key];
    }

    return function () {
        var _this = this;

        var args = arguments;
        fns.forEach(function (fn) {
            fn && fn.apply(_this, args);
        });
    };
}

var UiwTooltip = function (_Component) {
    _inherits(UiwTooltip, _Component);

    function UiwTooltip(props) {
        _classCallCheck(this, UiwTooltip);

        // this.handleOverlayShow = this.handleOverlayShow.bind(this);
        // this.handleOverlayHide = this.handleOverlayHide.bind(this);

        var _this2 = _possibleConstructorReturn(this, (UiwTooltip.__proto__ || Object.getPrototypeOf(UiwTooltip)).call(this, props));

        _this2.handleOverlayShow = _this2.handleMouseOverOut.bind(_this2, _this2.handleOverlayShow);
        _this2.handleOverlayHide = _this2.handleMouseOverOut.bind(_this2, _this2.handleOverlayHide);

        _this2.state = {
            isOverlayShown: false
        };
        return _this2;
    }

    _createClass(UiwTooltip, [{
        key: "componentDidMount",
        value: function componentDidMount() {
            this._el = _reactDom2.default.findDOMNode(this);
            this._container = document.createElement("div");
        }

        /**
         * Invoked after the component has updated and has been flushed to the DOM.
         *
         * @param prevProps {Object} properties prior to the update.
         * @param prevState (Object} state prior to the update.
         */

    }, {
        key: "componentDidUpdate",
        value: function componentDidUpdate(prevProps, prevState) {
            if (!prevState.isOverlayShown && this.state.isOverlayShown) {
                // overlay has just been made visible.
                if (this._el) {
                    var overlay = this.renderOverlay();

                    _reactDom2.default.unstable_renderSubtreeIntoContainer(this, overlay, this._container);
                }
            } else if (prevState.isOverlayShown && !this.state.isOverlayShown) {
                // overlay has just been made invisible.
                _reactDom2.default.unmountComponentAtNode(this._container);
                // TODO: destroy overlay.
            }
        }
    }, {
        key: "componentWillUnmount",
        value: function componentWillUnmount() {
            _reactDom2.default.unmountComponentAtNode(this._container);
            this._el = null;
            this._container = null;
        }

        /**
         * Determine if an ellipsis (from text-overflow: ellipsis) is present in the given element.
         *
         * @param el {HTMLElement} the test subject.
         * @returns {boolean} true if an ellipsis is present, false if not.
         */

    }, {
        key: "hasEllipsis",
        value: function hasEllipsis(el) {
            return el.offsetWidth < el.scrollWidth;
        }
    }, {
        key: "render",
        value: function render() {
            if (!this.props.children) {
                // there are no children to use as a trigger, render nothing.
                return null;
            }

            var trigger = _react2.default.Children.only(this.props.children);
            var triggerProps = trigger.props;

            // if the overlay is to be visible, then ensure we augment the "aria-describedby" prop into the trigger
            // element so that it pairs with the corresponding overlay element for the tooltip.
            var props = _extends({}, triggerProps);
            if (this.state.isOverlayShown) {
                props["aria-describedby"] = this.state.id;
            }

            // if "hover" is a trigger for the tooltip, bind mouse-over/mouse-out handlers.
            if (this.props.trigger.indexOf("hover") !== -1) {
                props.onMouseOver = triggerFn(this.handleOverlayShow, this.props.onMouseOver, triggerProps.onMouseOver);
                props.onMouseOut = triggerFn(this.handleOverlayHide, this.props.onMouseOut, triggerProps.onMouseOut);
            }

            // if "focus" is a trigger for the tooltip, bind focus/blur handlers.
            if (this.props.trigger.indexOf("focus") !== -1) {
                props.onFocus = triggerFn(this.handleOverlayShow, this.props.onFocus, triggerProps.onFocus);
                props.onBlur = triggerFn(this.handleOverlayHide, this.props.onBlur, triggerProps.onBlur);
            }

            return (0, _react.cloneElement)(trigger, props);
        }
    }, {
        key: "renderOverlay",
        value: function renderOverlay() {
            var _this3 = this;

            var text = this.props.tooltipText || this._el.textContent;
            var tooltip = _react2.default.createElement(
                _reactBootstrap.Tooltip,
                { id: this.state.id },
                text
            );
            var overlayProps = {
                placement: this.props.placement || "top",
                show: this.state.isOverlayShown,
                target: function target() {
                    return _this3._el;
                }
            };
            return _react2.default.createElement(
                _reactBootstrap.Overlay,
                overlayProps,
                tooltip
            );
        }

        /**
         * Handler used for when the tooltip should be hidden.
         */

    }, {
        key: "handleOverlayHide",
        value: function handleOverlayHide(ev) {
            this.state.isOverlayShown && this.setState({ isOverlayShown: false });
        }

        /**
         * Handler used for when the tooltip should be shown.
         */

    }, {
        key: "handleOverlayShow",
        value: function handleOverlayShow(ev) {
            if (!this.state.isOverlayShown) {
                var isEnabled = this.props.tooltipText || this.hasEllipsis(ev.target);
                if (isEnabled) {
                    var state = { isOverlayShown: true, id: this.state.id || generateId() };
                    this.setState(state);
                }
            }
        }

        // Simple implementation of mouseEnter and mouseLeave.
        // React's built version is broken: https://github.com/facebook/react/issues/4251
        // for cases when the trigger is disabled and mouseOut/Over can cause flicker moving
        // from one child element to another.

    }, {
        key: "handleMouseOverOut",
        value: function handleMouseOverOut(handler, e) {
            var target = e.currentTarget;
            var related = e.relatedTarget || e.nativeEvent.toElement;

            if (!related || related !== target && !(0, _contains2.default)(target, related)) {
                handler.call(this, e);
            }
        }
    }]);

    return UiwTooltip;
}(_react.Component);

UiwTooltip.defaultProps = {
    trigger: ["focus", "hover"]
};
UiwTooltip.propTypes = {
    tooltipText: _propTypes2.default.string
};
exports.default = UiwTooltip;
//# sourceMappingURL=Tooltip.js.map